module.exports = {
  footerText: 'İşim İçin © 2025',
}
